import { BarMenuItemTagType } from './bar-menu-item-tag-type.enum';

/** Represents a tag used in a menu item */
export class BarMenuItemTag {
    /** Content of the tag, this can be html (no angular binding supported)
     * e.g. "2", "<span class='fas fa-exclamation'></span> 2",... */
    content: string;
    /** The type of the menu item, default is not specified */
    type?: BarMenuItemTagType;
    /** Tooltip used to display clarifiing text of the tag */
    tooltip?: string;
    /** Additional classes to be put upon the tag */
    class?: string;
}
